export default class Clock {

	/**
	 * 
	 * @param {Object} args
	 * @param {Function} args.task function that will be fired repeatedly, passes the number of times the function has been fired as an argument
	 * @param {Number} args.interval miliseconds between firings
	 * @param {Number} args.repeat number of times to repeat (default -1 = infinite)
	 * @param {Boolean} args.dormant begin in a dormant state
	 * @param {Boolean} args.persistent won't destroy self when number of repeats executed
	 * @param {Boolean} args.instant first tick happens immediately
	 */
	constructor(args) {
		this.task = args.task;
		this.interval = args.interval || 1000;
		this.repeat = args.repeat || -1;
		this.persistent = args.persistent;
		this.active = !args.dormant;
		this.time = args.instant ? 0 : this.interval;
		this.counter = 0;
		this.destroyed = false;
	}

	update(delta) {
		if(this.active) {
			this.time -= delta;
			if(this.time < 0) {
				this.time += this.interval;
				this.counter++;
				this.task(this.counter);
				if(this.counter == this.repeat) {
					this.active = false;
					if(!this.persistent) this.destroyed = true;
				}
			}
		}
	}

	reset() {
		this.time = this.interval;
		this.active = true;
		this.counter = 0;
	}

}